/**
 * Katalog der Stile der Ego-Ansicht.
 *
 * Bewusst ohne three-Import und ohne Bezug auf die Theme-Klassen: `viewStore`
 * und Einstellungs-Popover muessen wissen, welche Stile es gibt, duerfen aber
 * nicht die Registry laden. Die zieht three und beide Welten ins Bundle, und
 * damit waere die Lazy-Load-Strategie von `createView` dahin — wer bei der
 * Draufsicht bleibt, soll die 3D-Technik nie laden.
 *
 * Die Registry bedient sich hier; ein Test haelt beide synchron.
 */

/** Stil, wenn niemand ausdruecklich etwas anderes gewaehlt hat. */
export const STIL3D_STANDARD = 'dungeon';

export interface Stil3dEintrag {
  /** Schluessel in der `theme3dRegistry`. */
  name: string;
  /** Beschriftung im Einstellungs-Popover. */
  label: string;
}

/**
 * Was die Einstellungen zur Wahl stellen.
 *
 * `plain` steht absichtlich nicht hier: der flache Buero-Stil ist die
 * Referenz zum Vergleichen und Messen, kein Angebot an alle. Ueber
 * `?theme3d=plain` bleibt er erreichbar.
 */
export const STIL3D_AUSWAHL: ReadonlyArray<Stil3dEintrag> = [
  { name: 'dungeon', label: 'Gewölbe' },
  { name: 'raumschiff', label: 'Sternenschiff' },
];

/**
 * Welcher Stil zu welchem `theme`-Feld einer Karte gehoert, und ob das
 * Geraet ihn ueberstimmen darf. Das Buero (`flat`) laesst die Wahl; ein
 * Stadion ist ein Stadion — Gewoelbe und Sternenschiff wuerden auf 43 000
 * Kacheln sekundenlang Licht backen und ergaeben trotzdem keinen Sinn.
 */
export interface KartenStil {
  stil: string;
  waehlbar: boolean;
}

export const STIL_JE_KARTENTHEME: Readonly<Record<string, KartenStil>> = {
  flat: { stil: STIL3D_STANDARD, waehlbar: true },
  stadion: { stil: 'stadion', waehlbar: false },
};

/** Stil einer Karte; unbekannte Karten-Themes verhalten sich wie das Buero. */
export function kartenStil(mapTheme: string): KartenStil {
  return STIL_JE_KARTENTHEME[mapTheme] ?? { stil: STIL3D_STANDARD, waehlbar: true };
}

/** Darf das Geraet den Stil dieser Karte im Einstellungsmenue umschalten? */
export function stilWaehlbar(mapTheme: string): boolean {
  return kartenStil(mapTheme).waehlbar;
}

/** Alle gueltigen Namen — die Auswahl plus die nur ueber die Adresse erreichbaren. */
const BEKANNTE_NAMEN: ReadonlySet<string> = new Set([
  'plain',
  ...STIL3D_AUSWAHL.map((e) => e.name),
  ...Object.values(STIL_JE_KARTENTHEME).map((k) => k.stil),
]);

/**
 * Gespeicherte Wahl gegen die bekannten Stile pruefen.
 *
 * Unsinn wird zu `null`, also "keine ausdrueckliche Wahl". Die Registry
 * faellt bei unbekannten Namen ohnehin still auf den Standard zurueck; so
 * zeigt auch das Popover den Stil an, der tatsaechlich zu sehen ist.
 */
export function normalisiereStil3d(wert: unknown): string | null {
  return typeof wert === 'string' && BEKANNTE_NAMEN.has(wert) ? wert : null;
}
